import React, { useState } from "react";
import { Button, Modal, Checkbox } from "antd";

const AlertFn = ({ visible, onClose, onSure, alertBolType }) => {
  console.log({ alertBolType });
  const [checked, setChecked] = useState(false);
  const name = alertBolType === 1 ? "微信账号" : "手机账号";
  return (
    <Modal
      title="绑定提示"
      closable={false}
      onClose={onClose}
      visible={visible}
      footer={false}
    >
      <p style={{ textAlign: "justify" }}>
        <span className="gray-font">
          系统检测到您的{name}已是平台注册账号。如您继续操作绑定，
        </span>
        <span className="red-font">
          意味您将自动放弃原{name}
          产生的所有数据（包括待提现的金额），且不可恢复
        </span>
        <span className="gray-font">，您还要继续吗？</span>
      </p>
      <Checkbox
        checked={checked}
        onChange={e => {
          setChecked(e.target.checked);
        }}
      >
        我同意放弃原账号的数据
      </Checkbox>
      <div className="btns" style={{ marginTop: 20 }}>
        <Button
          type="primary"
          className="grayBtn"
          onClick={() => {
            onClose();
          }}
          style={{ width: "40%", padding: 0 }}
        >
          更换绑定手机号
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          disabled={!checked}
          onClick={onSure}
          style={{ width: "40%", padding: 0 }}
        >
          确认绑定
        </Button>
      </div>
    </Modal>
  );
};

export default AlertFn;
